module.exports = __webpack_public_path__ + "static/adelle_bolditalic-webfont-woff-2f169adac1dc595df257fb39a049a26e.woff";